// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.counter-column{box-sizing:border-box;width:2.1rem;border-right:0.1rem solid silver;border-left:0.1rem solid silver;font-size:1.2rem}.counter-column .counter-box{text-align:center;margin-top:-0.8rem;margin-bottom:0.8rem;height:3.9rem}.counter-column .counter-box:last-child{margin-bottom:0;height:4.8rem}\n", ""]);
// Exports
module.exports = exports;
